// Conversion / cross-app link helpers — every link from this calculator to
// nztaxation.nz gets UTM tagged so conversions are attributable.

const NZTAX_BASE = "https://www.nztaxation.nz";
const SOURCE = "tradie-calculator";

export function nzTaxLink(path = "/", campaign = "general", extra = {}) {
  const url = new URL(path.startsWith("http") ? path : NZTAX_BASE + path);
  url.searchParams.set("utm_source", SOURCE);
  url.searchParams.set("utm_medium", "app");
  url.searchParams.set("utm_campaign", campaign);
  for (const [k, v] of Object.entries(extra)) url.searchParams.set(k, v);
  return url.toString();
}

export function bookCallLink(campaign = "book-call") {
  // No Calendly link configured yet — fall back to a pre-filled email.
  // Once the user provides a booking URL, swap this single function.
  const subject = encodeURIComponent("Booking a free 15-min call — Tradie Calculator");
  const body = encodeURIComponent(
    "Kia ora,\n\nI'm using your Tradie Calculator and would like to book a free 15-min call to discuss tax and bookkeeping for my business.\n\nName:\nBusiness:\nPhone:\nIdeal time (NZ):\n\nThanks!",
  );
  // Track the intent on the main site as well by linking through nztaxation.nz/#contact first
  return `mailto:info@nztaxation.nz?subject=${subject}&body=${body}`;
}

// Pricing tiers mirrored from nztaxation.nz (Sole Trader plans). Source of truth
// is the main site — update these if pricing changes there.
export const SOLE_TRADER_PLANS = [
  {
    key: "starter",
    name: "Starter",
    price: 59,
    blurb: "Non-GST contractors on schedular payments",
    features: [
      "Monthly tax position email",
      "Prosaic subscription included",
      "End-of-year tax return",
      "Email support (48h)",
    ],
    popular: false,
    campaign: "sole-trader-starter",
  },
  {
    key: "growth",
    name: "Growth",
    price: 75,
    blurb: "GST-registered contractors, 1 main client",
    features: [
      "Everything in Starter",
      "Monthly Prosaic review",
      "GST returns prepared & filed",
      "Priority support (24h)",
    ],
    popular: true,
    campaign: "sole-trader-growth",
  },
  {
    key: "premium",
    name: "Premium",
    price: 139,
    blurb: "Multiple customers — hands-off tax & books",
    features: [
      "Everything in Growth",
      "Full monthly bookkeeping",
      "Provisional tax planning",
      "Monthly strategy call",
    ],
    popular: false,
    campaign: "sole-trader-premium",
  },
];
